import { createAppButton } from 'owa-command-ribbon';
import ImageRegular from 'owa-fluent-icons-svg/lib/icons/ImageRegular';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { EventHandler } from '../../utils/controlInfo';
import type { IButtonStyles } from '@fluentui/react';
import loc from 'owa-localize';
import { inlineImageText } from '../../utils/actionControlStrings.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { IKeytipProps } from '@fluentui/react/lib/Keytip';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import { ActionControlId } from 'owa-ribbon-ids';

export const getAddInlineImagesControl = computedFn(
    (
        id: string | number,
        onAddInlineImage: EventHandler,
        styles: IButtonStyles | undefined,
        label: string | undefined,
        tooltip: string | undefined,
        isButtonDisabled: boolean | undefined,
        keytipProps: IKeytipProps | undefined,
        icon: string | undefined
    ): RibbonControlProps =>
        createAppButton(
            id,
            label ?? loc(inlineImageText),
            onAddInlineImage,
            isFeatureEnabled('mon-ribbon-keytips') ? keytipProps : undefined,
            icon ?? ImageRegular,
            undefined /* iconColor */,
            styles,
            isButtonDisabled != undefined
                ? {
                      customTooltip:
                          tooltip ??
                          getHoverTooltip(
                              ActionControlId.AddInlineImage,
                              label ?? loc(inlineImageText)
                          ),
                      disabled: isButtonDisabled,
                  }
                : undefined
        )
);
